import React from 'react';
import CreditFacility from './CreditFacility';
import ChargeCard from './ChargeCard';
import RepaymentLoan from './RepaymentLoan';
import DuplicateLetter from './DuplicateLetter';
import ConsentActive from './ConsentActive';
import ConsentInactive from './ConsentInactive';

class Accordion extends React.Component {

    static renderLoanTypes(type, loans, indexType, summary){
        if (type === "creditFacility") {
            return <CreditFacility loans={loans} indexType={indexType} summary={summary}/>
        }
        else if (type === "chargeCard") {
            return <ChargeCard loans={loans} indexType={indexType} summary={summary}/>
        }
        else if (type === "repaymentLoan") {
            return <RepaymentLoan loans={loans} indexType={indexType} summary={summary}/>
        }
        else if (type === "gjenpartsbrev") {
            return <DuplicateLetter loans={loans} indexType={indexType} summary={summary}/>
        }
        else if (type === "consentActive") {
            return <ConsentActive loans={loans} indexType={indexType} summary={summary}/>
        }
        else if (type === "consentInactive") {
            return <ConsentInactive loans={loans} indexType={indexType} summary={summary}/>
        }
    }

    static mapLoanNames(type) {
        if (type === "creditFacility") {
            return "Rammekreditt";
        }
        else if (type === "chargeCard") {
            return "Faktureringskort";
        }
        else if (type === "repaymentLoan") {
            return "Nedbetalingslån";
        }
        else if (type === "gjenpartsbrev") {
            return "Gjenpartsbrev siste 30 dager";
        }
        else if (type === "consentActive") {
            return "Mine aktive samtykker";
        }
        else if (type === "consentInactive") {
            return "Mine utgåtte samtykker";
        }
        else {
            return type;
        }
    }


    render() {

        var summary = this.props.summary;

        if (Array.isArray(this.props.list)) {
            return this.props.list.map(function (index, indexType) {
                if ((index.loans.errorMessage !== undefined && index.loans.length === undefined) || (index.loans.errorMessage === undefined && index.loans.length > 0)) {

                    return <div key={indexType} className='card'>
                        <div className='accord collapsed' id={'heading' + indexType} type='button' data-toggle='collapse' data-target={'#collapse' + indexType} href={'#collapse' + indexType}
                             aria-expanded='false'
                             aria-controls={'collapse' + indexType}>
                            <div className='accordDiv'>
                                <i className="fa circle-icon" aria-hidden="true"></i>
                                <span className='accordHeading'>{Accordion.mapLoanNames(index.type)}</span>
                            </div>
                        </div>
                        {Accordion.renderLoanTypes(index.type, index.loans, indexType, summary)}
                    </div>
                }
                else {
                    return null;
                }

            })
        }
        else return null;

    }
}


export default Accordion;

